import { config } from '../../utilities/config';
import keycloak from '../../keycloak';

export async function fetchEpsGroupsApi(organizationId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/emission-profile-group`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    }
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function createEpsGroupApi(organizationId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/emission-profile-group`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function editEpsGroupApi(organizationId, epsGroupId, data) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/emission-profile-group/${epsGroupId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function removeEpsGroupApi(organizationId, epsGroupId) {
  const response = await fetch(`${config.API_BASE_URL}/${organizationId}/emission-profile-group/${epsGroupId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`
    }
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}

export async function fetchAssignedEpsForEpsGroupApi(organizationId, epsGroupId) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/emission-profile-group/${epsGroupId}/assigned-eps`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`
      }
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

export async function fetchAvailableEpsToEpsGroupApi(organizationId, epsGroupId) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/emission-profile-group/${epsGroupId}/available-eps`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`
      }
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
  return data;
}

export async function assignEpsToEpsGroupApi(organizationId, epsGroupId, data) {
  const response = await fetch(
    `${config.API_BASE_URL}/${organizationId}/emission-profile-group/${epsGroupId}/assigned-eps`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`
      },
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (!response.ok) throw new Error(result.message);
  return result;
}
